import clsx from "clsx";
import { Link } from "react-router-dom";
import { TextBadge, SectionTitle, Subtitle } from "components/atoms/Text";
import DisclosureItem from "./DisclosureItem";
import { pricingQuestionList } from "data/pricingQuestionList";

const FrequentlyAsked = () => {
    return (
        <section className={clsx(
            "w-full phone:py-12 desktop:pt-20 desktop:pb-[104px] tablet:py-[64px] bg-neutral-10 max-w-[1440px] mx-auto",
            "px-6 tablet:px-8 desktop:px-[120px]",
            "flex flex-col md:flex-row justify-between"
        )}>
            <div className="max-w-full tablet:max-w-[360px] desktop:max-w-[414px]">
                <TextBadge>FAQ</TextBadge>
                <SectionTitle classNames="tablet:!text-[40px] tablet:!leading-[54px]">Frequently Asked Question</SectionTitle>
                <Subtitle classNames="pb-8 phone:!text-[18px] desktop:!text-[18px]">Can’t find answer you’re looking for?</Subtitle>
                <Link to="/support/contact" className="relative z-20">
                    <button className="h-[56px] w-full md:w-fit px-6 leading-[19.83px] font-semibold rounded-lg bg-primary-main hover:bg-primary-hover text-md text-basier-circle-semibold text-neutral-10">Reach Out to Us</button>
                </Link>
            </div>
            <div className="w-full flex flex-col max-w-full tablet:max-w-[550px] desktop:max-w-[616px] mt-8 md:mt-0">
                {pricingQuestionList.map((item) => (
                    <DisclosureItem key={item.id} question={item.question} answer={item.answer} />
                ))}
            </div>
        </section>
    );
};

export default FrequentlyAsked;